const itemSelected = (currentPath: string, path: string, isFirst: boolean) => {
  if (isFirst) {
    return path === currentPath;
  }
  return currentPath ? currentPath.startsWith(path) : false;
};

export default itemSelected;
